export const DELIMITER = '-{/./:}-' as const;
export const LEFT_BRACKET = '-{LEFT_BRACKET}-' as const;
export const RIGHT_BRACKET = '-{RIGHT_BRACKET}-' as const;
export const SEPARATOR = '.' as const;
